import React , {useState  , createContext , useEffect } from 'react'
import LoginModal from '../../../components/NewVersion/loginModal'
import SignIn from '../SignIn'
import {Container} from "react-bootstrap"
import './index.scss'
import SignUp from '../SignUp'
import Context from '../_context'
import ForgotPass from '../ForgotPass/ForgotPass'

const Newlogin = ({
    show ,
    onHide
}) => {
  const [ activePage , setActivePage ] = useState("signIn")
  
  return (
      //   <LoginModal
      //    show={show}
      //    onHide={onHide}
      //    variant="white"
      //    title=""
      //    closeBtn
      //    className=""
      //    size={activePage == "signUp" ? "lg" : "md"}
      //    titleClassName="border-0"
      // >
        <Container className="loginModal d-flex justify-content-center align-items-center py-4 px-4">
             
            {/* {number == 1 && <SignUp/>  } */}
            <Context.Provider value={[ activePage , setActivePage ]}>
              {activePage == "signIn" && <SignIn onHide={onHide} />  }
              {activePage == "signUp" && <SignUp/>  }
              {activePage == "forgotPass" && <ForgotPass/>  } 
            </Context.Provider>
            
        </Container>
        

      // </LoginModal>
  )
}

export default Newlogin